import React, { createRef, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { isEmpty } from 'lodash';

import { Grid } from '~/components';
import api from '~/services/api';
import {
  storeInRequest,
  recordFiltering,
  resetFiltering,
} from '~/store/modules/estoqueproduto/actions';

import { Graph, RefreshStock } from './components';

export default function EstoqueProduto() {
  const estoqueProduto = useSelector((state) => state.estoqueproduto);

  const [posto, setPosto] = useState(false);
  const [combo, setCombo] = useState([]);

  const refStock = createRef();

  async function handleTogglePostoComboio() {
    const { data } = await api.get('postosporusuario', {
      params: { pagesize: 99999 },
    });

    await setCombo(data.items);
  }

  async function handleToggleCombo(value) {
    await setPosto(false);

    if (!isEmpty(value.combo)) {
      await setPosto(value.combo.poco_codigo);
      await api.post('estoquespostoscomboios/gravaauditoriaacesso', {
        whereField: ["poco_codigo", "poco_descricao"],
        valueWhereField: [value.combo.poco_codigo, value.combo.poco_descricao],
        typeWhereField: ["EQUALS", "EQUALS"],
        orderField: "",
        ordination: ""

      })
    }
  }


  useEffect(() => {
    handleTogglePostoComboio();
  }, []);

  return (
    <>
      <Grid
        state={estoqueProduto}
        read={storeInRequest}
        filter={recordFiltering}
        reset={resetFiltering}
        timeOut={30000}
        component={(props) => (
          <Graph
            {...props}
            refresh={(product) => refStock.current.handleToggleModal(product)}
          />
        )}
        unique={{
          wherefield: 'poco_codigo',
          valuewherefield: posto,
          typewherefield: 'EQUALS',
        }}
        toolbar={[
          {
            type: 'select',
            name: 'combo',
            options: combo,
            label: 'poco_desc_abrev',
          },
        ]}
        changeToolbar={(value) => handleToggleCombo(value)}
        onStart={!!posto}
      />

      <RefreshStock ref={refStock} />
    </>
  );
}
